export default {
    postMessageToApp(message) {
        const stringifiedMessageObj = JSON.stringify(message)
        if (window.webkit && window.webkit.messageHandlers) {
            window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj)
        }
    }
}